/**
 * Where to send someone back to after they sign in.
 *
 * Extracted from app.ts because it now has a SECOND writer: the scheduled
 * report download landing (`cos-report-download`) is a public route that
 * decides for itself whether the link it is holding needs a session, so it
 * has to be able to capture a return path without going through the auth
 * guard. Two copies of this key would be one copy too many.
 */

/** The sessionStorage key app.ts reads after a successful auth round-trip. */
export const LOGIN_REDIRECT_KEY = 'cos.redirect_after_login';

/**
 * Capture the current path before bouncing to /login, so the post-login
 * flow lands the visitor back where they were heading.
 */
export function captureRedirectAfterLogin(): void {
	try {
		const here = window.location.pathname + window.location.search;
		// Don't capture /login itself — that would loop.
		if (here.startsWith('/login')) return;
		sessionStorage.setItem(LOGIN_REDIRECT_KEY, here);
	} catch {
		/* sessionStorage may be unavailable; degrade silently */
	}
}
